'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionSwapHoriz = function ActionSwapHoriz(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z' })
  );
};
ActionSwapHoriz = (0, _pure2.default)(ActionSwapHoriz);
ActionSwapHoriz.displayName = 'ActionSwapHoriz';
ActionSwapHoriz.muiName = 'SvgIcon';

exports.default = ActionSwapHoriz;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/action/swap-horiz.js
// module id = 1059
// module chunks = 0